<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo">
            <div class="logo-icon">
              <div class="logo-circle"></div>
              <div class="logo-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <h3>企业通讯录</h3>
          </div>
          <p>连接全产业链的智能通讯录平台，为企业提供全方位的商务沟通解决方案</p>
          <div class="social-links">
            <a href="#" class="social-link">
              <span class="social-icon">📧</span>
            </a>
            <a href="#" class="social-link">
              <span class="social-icon">💬</span>
            </a>
            <a href="#" class="social-link">
              <span class="social-icon">📱</span>
            </a>
          </div>
        </div>
        
        <div class="footer-section">
          <h4>产品服务</h4>
          <ul class="footer-links">
            <li><a href="#">智能通讯录</a></li>
            <li><a href="#">产业链对接</a></li>
            <li><a href="#">商务沟通</a></li>
            <li><a href="#">数据分析</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>关于我们</h4>
          <ul class="footer-links">
            <li><a href="#">公司简介</a></li>
            <li><a href="#">加入我们</a></li>
            <li><a href="#">新闻动态</a></li>
            <li><a href="#">合作伙伴</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>法律条款</h4>
          <ul class="footer-links">
            <li><a href="#">用户协议</a></li>
            <li><a href="#">隐私政策</a></li>
            <li><a href="#">服务条款</a></li>
            <li><a href="#">免责声明</a></li>
          </ul>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-info">
          <p>&copy; 2024 企业通讯录科技有限公司. 保留所有权利.</p>
          <p>粤ICP备2024000000号 | 粤网信备44010000000000000000号</p>
        </div>
        <div class="footer-back-to-top">
          <button @click="scrollToTop" class="back-to-top-btn">
            <span class="arrow">↑</span>
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.footer {
  background: #0a0e17;
  color: #ffffff;
  padding: 60px 0 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section h4 {
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 20px;
}

.footer-section p {
  color: #8892b0;
  line-height: 1.6;
  margin-bottom: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.logo-icon {
  position: relative;
  width: 32px;
  height: 32px;
}

.logo-circle {
  width: 100%;
  height: 100%;
  border: 2px solid #00d4ff;
  border-radius: 50%;
  position: relative;
  animation: pulse 2s infinite;
}

.logo-circle::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #00d4ff;
  border-radius: 50%;
  box-shadow: 0 0 10px #00d4ff;
}

.logo-dots {
  position: absolute;
  top: -2px;
  right: -2px;
  display: flex;
  gap: 2px;
}

.logo-dots span {
  width: 4px;
  height: 4px;
  background: #00d4ff;
  border-radius: 50%;
  animation: blink 1.5s infinite;
}

.logo-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.logo-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.footer-logo h3 {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.5rem;
  background: linear-gradient(45deg, #00d4ff, #0099cc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.social-links {
  display: flex;
  gap: 16px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border-color: #00d4ff;
  transform: translateY(-2px);
}

.social-icon {
  font-size: 1.2rem;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #8892b0;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.95rem;
}

.footer-links a:hover {
  color: #00d4ff;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-info p {
  color: #8892b0;
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.back-to-top-btn {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  border: none;
  border-radius: 50%;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-to-top-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 212, 255, 0.3);
}

.arrow {
  font-size: 1.2rem;
  font-weight: bold;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.4);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(0, 212, 255, 0);
  }
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0.3;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
  
  .footer-logo {
    justify-content: center;
  }
  
  .social-links {
    justify-content: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .footer-info p {
    font-size: 0.8rem;
  }
}
</style>
